import { client } from './axiosClient';
import { Invitation, InvitationWithCompanyName } from '../types';

export const getInvitationPublic = async (hash: string) => {
  const res = await client.get<InvitationWithCompanyName>('/app/invitation', {
    params: {
      hash,
    },
  });
  return res.data;
};

export const getInvitationByHash = async (hash: string) => {
  const res = await client.get<InvitationWithCompanyName>(
    `/client/invitations/by-hash/${hash}`
  );
  return res.data;
};
export const getInvitations = async (company_id?: string) => {
  const res = await client.get<Invitation[]>('/client/invitations', {
    params: {
      company_id,
    },
  });
  return res.data;
};

export const postInvitation = async (company_id: string, email: string) => {
  const res = await client.post<Invitation>(
    '/client/invitations',
    {
      email,
    },
    {
      params: {
        company_id,
      },
    }
  );
  return res.data;
};

export const postCancelInvitation = async (company_id: string, id: number) => {
  const res = await client.post<Invitation>(
    `/client/invitations/${id}/cancel`,
    undefined,
    {
      params: {
        company_id,
      },
    }
  );
  return res.data;
};

export const postResendInvitation = async (company_id: string, id: number) => {
  const res = await client.post<Invitation>(
    `/client/invitations/${id}/resend`,
    undefined,
    {
      params: {
        company_id,
      },
    }
  );
  return res.data;
};

export const postRespondInvitation = async (
  invitation_id: string,
  accepted: boolean
) => {
  const res = await client.post('/user/accept-invitation', {
    invitation_id,
    accepted,
  });
  return res.data;
};
